<template>
  <!-- 研究 -->
  <div class="page-research">
    <div class="g-banner">
      <cmpBanner bannerType="2"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>
    <div class="g-content-wrap g-pad-top">
      <cmpSubTab ref="cmpSubTab" :tabs="subTabList" :activeVal="activeSubVal"
        v-if="activeVal === '1' || activeVal === '3'" @eventTabClick="eventSubTabClick"></cmpSubTab>

      <!-- 常设展览 -->
      <div v-if="activeVal === '0'">
        <div class="list">
          <div class="item-inner" v-for="(item, index) in dataList" @click="goDetail(item)" :key="index">
            <div class="item1">
              <div class="pic-box">
                <img v-lazy="item.mainPic" alt="" />
              </div>
              <div class="info1 flex-col">
                <span class="title pf-regular">{{ item.name }}</span>
                <div class="add-wrapper pf-regular">
                  <p class="time">常设展览</p>
                  <p>{{ item.address }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>
      </div>

      <div class="list mt-48" v-if="activeVal === '1'">
        <div class="item-inner" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="item1">
            <div class="pic-box">
              <img v-lazy="item.mainPic" alt="" />
            </div>
            <div class="info1 flex-col">
              <h2 class="title pf-regular mb-10">{{ item.name }}</h2>
              <p class="time1 ">
                {{ item.beginTime.replaceAll('-', '.') }}-{{
                item.endTime.replaceAll('-', '.')
              }}
              </p>
              <p class="intro ell">{{ item.address }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 微展览 -->
      <div class="list" v-if="activeVal === '2'">
        <div class="qrcode" ref="qrCode"></div>

        <div class="item-inner" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="item1">
            <div class="pic-box">
              <img v-lazy="item.mainPic" alt="" />
            </div>
            <div class="info1 flex-col">
              <h2 class="title pf-regular ell">{{ item.name }}</h2>
              <!-- <div class="flex-box p-r">
                <span class="span-bg sm" @click="mouseenter($event,index)">扫码看展</span>
                <img class="img-qrCode" :ref="`imgQrCode_${index}`" :src="item.qrCode" alt="">
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="list" v-if="activeVal === '4'">
        <div class="item-inner" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
          <div class="item1">
            <div class="pic-box">
              <img v-lazy="item.szztfm" alt="" />
            </div>
            <div class="info1 flex-row">
              <h2 class="title pf-regular ell">{{ item.name }}</h2>
              <span class="span-bg pf-regular ml-40"><img src="../../assets/images/icon_360@2x.png" alt=""></span>
            </div>
          </div>
        </div>
      </div>

      <!-- 无数据 -->
      <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
        <div class="no-data-bg"></div>
        <p class="txt text-center">暂无数据</p>
      </div>

      <cmpMyPagination v-if="dataList.length > 0" :currentPage="listQuery.currentPage" :pageSize="listQuery.size"
        :total="total" @eventPage="eventPage"></cmpMyPagination>
    </div>
  </div>
</template>

<script>
// import Carsoul from '@cmp/header/carsoul'
import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"
import cmpTab from '@cmp/tab'
import cmpSubTab from '@cmp/tab/sub-tab'
export default {
  components: { cmpTab, cmpSubTab },
  data() {
    return {
      activeVal: '0',
      tabList: [
        {
          name: '常设展览',
          val: '0'
        },
        {
          name: '临时展览',
          val: '1'
        },
        {
          name: '微展览',
          val: '2'
        },
        {
          name: '数字展厅',
          val: '4'
        }
      ],
      activeSubVal: '1',
      subTabList: [
        {
          name: '正在展出',
          val: '1'
        },
        {
          name: '展览回顾',
          val: '3'
        }
      ],
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 9
      },
      total: 0,
      listLoading: false
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.from === 'footer') {
        this.$router.go(0)
      }
    }
  },
  methods: {
    createQrcode(obj) {
      new QRCode(this.$refs.qrCode, {
        text: obj.szzturl,
        width: 80,
        height: 80,
        colorDark: "#000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })

      html2canvas(this.$refs.qrCode, {
        backgroundColor: null,
        width: 80,
        height: 80
      }).then(canvas => {
        var imgData = canvas.toDataURL('image/jpeg')  //这里转为图片方式 `[base64转图片并显示](https://blog.csdn.net/weixin_45527702/article/details/117324946)`
        this.$set(obj, 'qrCode', imgData);
      })
    },

    mouseenter(evt, i) {
      evt.stopPropagation()
      if (!this.$refs[`imgQrCode_${i}`][0].style.opacity || this.$refs[`imgQrCode_${i}`][0].style.opacity == '0') {
        this.$refs[`imgQrCode_${i}`][0].style.opacity = '1'
      } else {
        this.$refs[`imgQrCode_${i}`][0].style.opacity = '0'
      }
    },

    getDataList() {
      this.listLoading = true
      this.dataList = []
      this.total = 0
      this.$http
        .get('../singleMuseum/applet/exhibition/zlList', {
          ...this.listQuery,
          type: this.activeVal == 1 ? this.activeSubVal : this.activeVal
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            this.dataList = data.records
            if (this.activeVal == 2) {
              this.dataList.map((item, index) => {
                this.$nextTick(() => {
                  this.createQrcode(item)
                });
                // QRCode.toDataURL(item.szzturl).then(res1 => {
                //   console.log(res1)
                // })
              })
            }
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },

    getClassDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/applet/exhibition/szztList', {
          ...this.listQuery
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      // this.listQuery.size = obj.size
      if (this.activeVal === '4') {
        if (!obj.size) {
          this.listQuery.size = 10
        } else {
          this.listQuery.size = obj.size
        }
        this.getClassDataList()
      } else {
        if (!obj.size) {
          this.listQuery.size = 9
        } else {
          this.listQuery.size = obj.size
        }
        this.getDataList()
      }
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.currentPage = 1
      this.$router.replace({ path: '/exhibition?type=' + val });

      if (this.activeVal === '4') {
        this.listQuery.size = 10
        this.getClassDataList()
      } else {
        this.listQuery.size = 9
        this.getDataList()
      }
    },
    eventSubTabClick(val) {
      this.activeSubVal = val
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetail(item) {
      if (this.activeVal == 2) {
        window.open(item.szzturl, '_blank')
      } else if (this.activeVal == 4) {
        window.open(item.pcUrl, '_blank')
      } else {
        this.$router.push({
          path: '/exhibition/detail',
          query: { id: item.id, pageType: this.$route.query.type }
        })
      }
      // if(this.activeVal === '3' || this.activeVal === '4') {
      //   this.$router.push({
      //     path: '/research/detail',
      //     query: {id: item.id, pageType: this.activeVal}
      //   })
      // } else {
      //   this.$router.push({
      //     path: '/alliance/detail',
      //     query: {id: item.id}
      //   })
      // }
    }
  },
  created() {
    this.activeVal = this.$route.query.type || '0'
    if (this.activeVal === '4') {
      this.listQuery.size = 10
      this.getClassDataList()
    } else {
      this.listQuery.size = 9
      this.getDataList()
    }
  }
}
</script>

<style lang="scss" scoped>
.page-research {
  /deep/.cmp-sub-tab-wrap {
    .item {
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .ml-40 {
    margin-left: 40px;
  }
  .mb-10 {
    margin-bottom: 0;
  }
  .qrcode {
    position: absolute;
    top: -80px;
    left: -80px;
    z-index: -99;
  }

  .list {
    &.mt-48 {
      margin-top: 48px;
    }
    .item-inner {
      cursor: pointer;
      margin-bottom: 40px;
      .item1 {
        display: flex;
        position: relative;
        flex-direction: column;
        .pic-box {
          width: 100%;
          height: 382px;
          background: #f6f6f6;
          border-radius: 4px 0px 0px 4px;
          flex-shrink: 0;
          img {
            width: 100%;
            height: 100%;
            transition: all 0.6s;
            object-fit: contain;
          }
        }
        .info1 {
          flex: 1;
          box-sizing: border-box;
          padding: 31px;
          background: #f6f6f6;
          // border: 1px solid rgba(#000000, 0.2);
          display: flex;
          // flex-direction: column;
          justify-content: space-between;
          .title {
            font-size: 32px;
            font-weight: 400;
            color: #000;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-bottom: 30px;
          }

          .time {
            color: #ae8148;
            line-height: 33px;
          }

          .mb-10 {
            margin-bottom: 10px;
          }

          .time1 {
            font-family: pf-normal;
            font-size: 26px;
            color: #000000;
            line-height: 33px;
          }

          .img-qrCode {
            opacity: 0;
            transition: all 0.5s;
            position: absolute;
            top: -102%;
            margin-bottom: 20px;
          }

          .span-bg {
            flex-shrink: 0;
            display: flex;
            width: 80px;
              height: 80px;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: #ae8148;
            &.sm {
              width: 160px;
              height: 160px;
              font-size: 26px;
              font-weight: 400;
              color: #f6f6f6;
            }
            img {
              width: 32px;
              height: 25px;
            }
          }

          .intro {
            margin-top: 30px;
            font-family: pf-normal;
            font-size: 26px;
            color: rgba($color: #000000, $alpha: 0.7);
          }

          .des {
            font-size: 26px;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
          }

          .add-wrapper {
            display: flex;
            justify-content: space-between;
            font-size: 26px;
            font-weight: 400;
            color: #000000;
            line-height: 38px;
          }
        }
      }
    }
  }
  .list3 {
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 49%;
      &:not(:nth-child(2n)) {
        margin-right: 2%;
      }
      .pic-box {
        width: 230px;
        height: 300px;
        background: $primary;
        padding: 10px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .info {
        .desc {
          height: 110px;
          overflow: hidden;
        }
      }
    }
  }

  .list4 {
    margin-bottom: 30px;
    position: relative;
    font-size: 14px;
    line-height: 24px;
    color: #595452;
    .child {
      position: relative;
      padding: 30px 30px;
      border-bottom: solid 1px rgba(#d6a884, 0.2);
      font-size: 18px;
      color: #45443e;
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:before,
        &:after {
          content: '';
          display: block;
          width: 16px;
          height: 22px;
          background: url(~@images/icon-bullet-active.png) no-repeat center
            center;
          background-size: 100%;
          position: absolute;
        }
        &:before {
          left: 0;
          top: 30px;
        }
        &:after {
          right: 0;
          top: 30px;
        }
        p {
          width: 930px;
        }
      }
      .author {
        font-size: 14px;
      }
    }
  }
}
</style>
